import { Card, Skeleton, Stack } from "@mui/material";

export default function FinalReportWeatherCardSkeleton() {
    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Skeleton variant="text" width={160} height={32} />
                <Skeleton variant="circular" width={40} height={40} />
            </Stack>
        </Card>
    );
}
